export default "__VITE_ASSET__BCFIfBNa__"